export default {"src":"/_next/static/media/mco.54918266.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};